import { Suspense } from 'react';
import { HelpButton } from 'components';
import { useV3ExperienceState } from 'hooks/useV3ExperienceState';

function V3ExperienceHelpButtonInner() {
  const { isInV3Experience } = useV3ExperienceState();
  if (!isInV3Experience) return null;
  return <HelpButton />;
}

export function V3ExperienceHelpButton() {
  return (
    <Suspense fallback={null}>
      <V3ExperienceHelpButtonInner />
    </Suspense>
  );
}
